import React from "react";
import styled from "styled-components";
import VialImage from "../../assets/vial-horizontal.png";
import Placeholder from "../../assets/placeholder.svg";
import DowntownCharlottesvilleImage from "../../assets/Downtown-Cville1.jpg";
import Kevin from "../../assets/kevin.jpg";
import CareerGrid from "../../assets/jobs-grid.png";
import CoupleImage from "../../assets/couple.png";

const ImageSourceMap = {
  vial: VialImage,
  downtownCharlottesville: DowntownCharlottesvilleImage,
  kevin: Kevin,
  CareerGrid: CareerGrid,
  placeholder: Placeholder,
  couple: CoupleImage
};

const ImageContainer = styled.div`
  display: grid;
  justify-content: ${({ align }) => align || "center"};
  width: ${({ full }) => (full ? "100%" : "80%")};
  flex: ${({ full }) => (full ? 1 : "none")};
  margin: 0 auto;
`;

const Image = styled.img`
  height: auto;
  width: 100%;
`;

const Caption = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.5rem;
`;

export default ({ image = "", caption, full = false, align = "center" }) =>
  <ImageContainer full={full} align={align} className="image">
    <Image src={image} />
    {caption &&
      <Caption>
        {caption}
      </Caption>}
  </ImageContainer>;



// WEBPACK FOOTER //
// ./src/components/Image.js